import React, { useState, useEffect } from "react";
// import GUI_Header from "./gui/GUI_Header";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
// import GUI_Credit from "./gui/GUI_Credit";
// import T from "./TheTool";// NOT WORK, old ver
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";
import GUIset_2Input from "./gui/GUIset_2Input";

const Sum = () => {
	useEffect(() => {
		document.title =
			"Subarray with given sum: which number in a list sum up to a certain number?";
	}, []);

	const [guiTxt1, guiTxtChange1] = useState("16"); //int
	const [guiTxt2, guiTxtChange2] = useState("1,2,3,5,6,10,11,12");
	// const [guiTxt2, guiTxtChange2] = useState("2,4,6,10,12");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxt1 != "" && guiTxt2 != "") {
			var target0 = parseInt(guiTxt1);
			var arr0 = T.str_toListInt(guiTxt2);
			//----------------------
			Timer.setTimeBudget(4999);
			Timer.start();
			process(target0, arr0);
			txt_time = Timer.stop_print();
			//--------------------------
			BuildResult();
			map = []; // int[][]
			arr = []; //Arrays of given items
			optimalSolution = [[]]; //
		}
	};

	var txt_time = "";
	var map = []; // int[][]
	var arr = []; //Arrays of given items
	var optimalSolution = [[]]; //
	var n_set = 0;

	function process(target0, arr0) {
		arr = arr0;
		n_set = countSets(target0);
		console.log("# of set " + n_set);
		if (n_set > 0) {
			getBestSet(target0);
			// txt_result = optimalSolution.join(" __ ");
			// console.log("RRR " + txt_result);
		}
	}

	//Count Negative
	function countSets(target) {
		// map = new int[arr.length][target + 1]; for(int a = 0; a < map.length;a++) {Arrays.fill(map[a],-99);}
		// console.log("CCCC " + arr.length + " ---- " + target);
		map = T.getMatrix(arr.length, target + 1, -99);
		return addItem(arr.length - 1, target);
	}

	//n is index of item being considered
	function addItem(n, remain) {
		// console.log("AAA " + n + " _ " + remain);
		if (n < 0) {
			return 0;
		} //Exceed
		var result = map[n][remain]; //check memory
		if (result < 0) {
			if (arr[n] > remain) {
				result = addItem(n - 1, remain);
			} //not add this, too big
			else if (arr[n] == remain) {
				result = 1 + addItem(n - 1, remain);
			} //add this (complete) + not add this
			else {
				result = addItem(n - 1, remain - arr[n]) + addItem(n - 1, remain);
			} //add this + not add this
			map[n][remain] = result;
		}
		return result;
	}

	//------------------------------
	function getBestSet(target) {
		arr = T.listSort_desc(arr);
		optimalSolution = [[]];
		addItem2([], target, 0);
	}

	//no return, optimal value go to 'optimalSolution'
	//list is 'list' of item collected so far, which sum up to 'remain', i is index of item in array being consider
	function addItem2(list, remain, i) {
		if (Timer.timeout()) {
			return;
		}
		//-------------------------------
		// console.log("LLL " + list + " left " + remain + " Consider " + arr[i]);
		var optimal_n = optimalSolution[0].length;
		// console.log("vs N " + optimal_n);
		if (remain < 0) {
		} else if (remain == 0) {
			if (optimal_n == 0 || list.length < optimal_n) {
				optimalSolution = [list];
				console.log("SET OPTIMAL " + list);
			} else if (list.length == optimal_n) {
				optimalSolution.push(list);
				console.log("ADD OPTIMAL " + list);
			}
		} else {
			if (i < arr.length) {
				//still need more item, first predict if this item will be better than optimal
				if (optimal_n == 0 || list.length < optimal_n + 1) {
					var x = arr[i];
					var list2 = T.listAdd(list, x);
					addItem2(list2, remain - x, i + 1); //add
					// console.log("CONT");
					addItem2(list, remain, i + 1); //skip
				}
			}
		}
	}

	//-------------------------
	function BuildResult() {
		// txt_result = optimalSolution.join(" __ ");
		// console.log("RRR " + txt_result);
		var txt = "";
		// var txt2 = "";
		var txt3 = "";
		var part1 = [<div></div>];
		var part2 = [<div></div>];
		var txtHead = "Subarray";
		//------------------------
		txt += txt_time;
		txt += Timer.reachLimit() ? " (limited)\n" : "\n";
		if (n_set < 1) {
			txt += "No possible subarray";
		} else {
			if (n_set == 1) {
				txt += "Possible subarray: 1";
			} else {
				txt += "Possible subarrays: " + n_set;
				txtHead += "s";
			}
			txtHead += " with the smallest number of elements";
			//---------
			// txt3 = "["+optimalSolution.join("]\n[")+"]";
			// if (txt3 == "") {
			// 	txt3 = "[ ]";
			// }
			for (var a = 0; a < optimalSolution.length; a++) {
				if (txt3 != "") {
					txt3 += "\n";
				}
				txt3 += "[" + optimalSolution[a].reverse() + "]";
			}
			// part2 = [
			// 	<div key="part2">
			// 		<br />
			// 		<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>
			// 			<b>Optimal Subarray</b>
			// 		</div>
			// 		<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>{txt3}</div>
			// 	</div>,
			// ];
			part2 = Template.simple00("key2", 1, txtHead, txt3, 20, 20);
		}
		// part1 = [
		// 	<div key="part1">
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>
		// 			<h2>Result</h2>
		// 		</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt}</div>
		// 	</div>,
		// ];
		part1 = Template.simple01("key1", "Result", txt, 20, 22);
		partResultChange(
			<div>
				{part1}
				<br />
				{part2}
			</div>
		);
	}

	//--------------------------------------------------------

	return (
		<GUIset_2Input
			title={"Subarray with given sum"}
			desc={
				"How many subsets can sum up to a certain number? (Find sets/arrays of numbers that add up to a given value)."
			}
			guiTxtChange1={guiTxtChange1}
			guiTxtChange2={guiTxtChange2}
			buttonClick1={buttonClick1}
			partResult={partResult}
			//------
			label1={"Target"}
			label2={"Items"}
			guiTxt1={guiTxt1}
			guiTxt2={guiTxt2}
			numberOnly1={true}
			numberOnly2={false}
			txtButton={"Calculate"}
			style={1}
		/>
	);
};

export default Sum;

// return (
// 	<div className="todoapp stack-large">
// 		<GUI_Header
// 			title={"Subarray with given sum"}
// 			desc={
// 				"How many subsets can sum up to a certain number? (Find sets/arrays of numbers that add up to a given value)."
// 			}
// 		/>
// 		<div style={{ marginTop: "3em" }}> </div>
// 		<GUI_InputTextSingle
// 			label={"Target"}
// 			text1={guiTxt1}
// 			text1Change={guiTxtChange1}
// 			numberOnly={true}
// 			fontSize2={28}
// 			width1={120}
// 			width2={'80%'}
// 		/>
// 		<GUI_InputTextSingle
// 			label={"Items"}
// 			text1={guiTxt2}
// 			text1Change={guiTxtChange2}
// 			numberOnly={false}
// 			fontSize2={24}
// 			width1={120}
// 			width2={'80%'}
// 		/>
// 		<div style={{ display: "flex", marginLeft: '20%', marginRight: '2%'   }}>
// 			<button
// 				onClick={() => buttonClick1()}
// 				className="btn btn__primary btn__lg"
// 				style={{ flex: 1, height: 50 }}
// 			>
// 				Calculate
// 			</button>
// 		</div>
// 		<div style={{ marginTop: "3em" }}> </div>
// 		{partResult}
// 		{/* {GetResult()} */}
// 		<GUI_Credit />
// 	</div>
// );
